<template>
  <div class="app-container">
    <div class="page-header">
      <div class="page-title">
        准时签收率看板 | SLA | Delivery | Time Out
      </div>
      <div class="header-right">
        <span>
          <el-button
            :type="queryList.mode === 'SLA' ? 'primary' : ''"
            size="small"
            @click="handleModeChange('SLA')"
          >SLA</el-button>
          <el-button
            :type="queryList.mode === 'DELIVERY' ? 'primary' : ''"
            size="small"
            @click="handleModeChange('DELIVERY')"
          >Delivery</el-button>
          <el-button
            :type="queryList.mode === 'TIMEOUT' ? 'primary' : ''"
            size="small"
            @click="handleModeChange('TIMEOUT')"
          >Time Out</el-button>
        </span>
        <span class="update-time">更新时间 Update time：<span class="time-text">{{ updateTime || '- -' }}</span>（há 3 dias）</span>
      </div>
    </div>
    <el-divider />

    <!-- 查询条件 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="queryList" class="search-form">
        <el-row
          :gutter="10" type="flex" justify="left"
          style="flex-wrap: wrap;align-items: flex-end"
        >
          <el-col
            :xs="12" :md="12" :sm="12"
            :lg="3" :xl="3"
          >
            <el-form-item label="大区 Região">
              <el-select
                v-model="queryList.regionId" size="small"
                clearable filterable
                :placeholder="$t('GlobalSetObj.all')"
                @change="handleRegionChange"
              >
                <el-option
                  v-for="item in regionList" :key="item.regionId" :label="item.regionName"
                  :value="item.regionId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="12" :md="12" :sm="12"
            :lg="3" :xl="3"
          >
            <el-form-item label="州 Estado/UF">
              <el-select
                v-model="queryList.states" size="small" clearable
                filterable multiple collapse-tags
                :placeholder="$t('GlobalSetObj.all')"
              >
                <el-option
                  v-for="(item, idx) in stateList" :key="idx" :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="12" :md="12" :sm="12"
            :lg="3" :xl="3"
          >
            <el-form-item label="客户名称 Nome do cliente">
              <el-select
                v-model="queryList.customerIds" size="small"
                :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
                clearable filterable
                multiple collapse-tags
                remote reserve-keyword
                :remote-method="getCustomerPage"
                style="width: 100%"
                @change="handleCustomerChange"
                @clear="getCustomerPage('')"
                @focus="getCustomerPage('', true)"
              >
                <el-option
                  v-for="item in customerList"
                  :key="item.id"
                  :label="item.customerAlias + '(' + item.username + ')'"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="12" :md="12" :sm="12"
            :lg="4" :xl="4"
          >
            <el-form-item label="商户名称 Nome do comerciante">
              <el-select
                v-model="queryList.merchantCodes" size="small" clearable
                filterable multiple collapse-tags
                :placeholder="$t('GlobalSetObj.all')"
              >
                <el-option
                  v-for="(item, index) in merchantList"
                  :key="index"
                  :label="item.merchantName + '（' + item.merchantCode + '）'"
                  :value="item.merchantCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="12" :md="12" :sm="12"
            :lg="3" :xl="3"
          >
            <el-form-item label="货物类型 Tipo de carga">
              <el-select
                v-model="queryList.packageType" size="small" clearable
                filterable :placeholder="$t('GlobalSetObj.pleaseChoose')"
              >
                <el-option :label="$t('GlobalSetObj.all')" value="" />
                <el-option :label="$t('placeOrder.Normal')" :value="1" />
                <el-option :label="$t('GlobalSetObj.big01')" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :xs="12" :md="12" :sm="12"
            :lg="4" :xl="4"
          >
            <el-form-item label="理应送达时间 Horário previsto">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                size="small"
                range-separator="~"
                start-placeholder="开始日期 Data inicial"
                end-placeholder="结束日期 Data final"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-col>
          <div class="search-buttons">
            <el-button
              size="small" type="primary" class="hover-move"
              @click="handleSearch"
            >搜索 Procurar</el-button>
            <el-button size="small" class="hover-move resetBtn" @click="handleReset">重置 Resetar</el-button>
          </div>
          <!-- 隐藏/显示所有 QTD 列 -->
          <div class="qtd-toggle">
            <el-tooltip
              :content="showQtd ? '显示 QTD 列 Mostrar colunas QTD' : '隐藏 QTD 列 Ocultar colunas QTD'"
              placement="top"
            >
              <el-button
                size="small"
                class="hover-move qtd-toggle-btn"
                @click="showQtd = !showQtd"
              >
                <i v-if="showQtd" class="el-icon-view qtd-toggle-icon" />
                <img
                  v-else src="/static/hide.png" class="qtd-toggle-icon"
                  alt="qtd"
                >
              </el-button>
            </el-tooltip>
          </div>
        </el-row>
      </el-form>
    </el-card>
    <el-divider />

    <!-- 每日达成 -->
    <DailyAchievement :res-data="dailyRes" :show-qtd="showQtd" />

    <!-- 每周达成 / 月度达成 -->
    <el-row :gutter="20" style="margin-left: 10px;margin-right: 10px;padding-bottom: 20px">
      <el-col :xs="24" :lg="12">
        <WeeklyAchievement :res-data="weeklyRes" :show-qtd="showQtd" />
      </el-col>
      <el-col :xs="24" :lg="12">
        <MonthlyAchievement :res-data="monthlyRes" :show-qtd="showQtd" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Loading } from 'element-ui';
import { apiCustomerPage, apimerchantName } from '@/api/customer';
import { onTimeSignRateAchieve, onTimeSignRateRSFilter, onTimeSignRateLastTime, getMerchantByCustomerIdList } from '@/api/orderApi';
import DailyAchievement from './component/DailyAchievement';
import WeeklyAchievement from './component/WeeklyAchievement';
import MonthlyAchievement from './component/MonthlyAchievement';

export default {
  name: 'OntimeDeliveryDashboard',
  components: {
    DailyAchievement,
    WeeklyAchievement,
    MonthlyAchievement
  },
  data() {
    return {
      regionList: [],
      stateList: [],
      customerList: [],
      selectedCustomerList: [],
      merchantList: [],
      updateTime: '',
      pickDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.pickDate = minDate;
          if (maxDate) {
            this.pickDate = null;
          }
        },
        disabledDate: (time) => {
          if (this.pickDate) {
            const oneDay = 24 * 3600 * 1000;
            const minTime = this.pickDate.getTime() - 89 * oneDay;
            const maxTime = this.pickDate.getTime() + 89 * oneDay;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
          return false;
        }
      },
      queryList: {
        mode: 'SLA', // 页签：SLA / DELIVERY / TIMEOUT（不区分大小写）
        granularity: '', // 时间粒度：DAY / WEEK / MONTH
        dateStart: '',
        dateEnd: '',
        regionId: '',
        states: [],
        customerIds: [],
        merchantCodes: [],
        packageType: ''
      },
      dateRange: [],
      showQtd: true, // 是否显示所有 QTD 列
      // 三个时间粒度的准时签收达成接口返回（由各达成子组件自行解析渲染）
      dailyRes: {}, // 【每日达成】接口返回
      weeklyRes: {}, // 【周度达成】接口返回
      monthlyRes: {} // 【月度达成】接口返回
    };
  },
  created() {
    this.getRSData();
    this.getCustomerPage();
    this.getMerchantList();
    this.initDateRange();
    this.handleSearch();
  },
  methods: {
    // 更新时间
    getUpdateTime() {
      onTimeSignRateLastTime().then(res => {
        this.updateTime = res.data;
      }).catch(() => {
        this.updateTime = '';
      });
    },
    initDateRange() {
      const endDate = dayjs().format('YYYY-MM-DD');
      const startDate = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
      this.dateRange = [startDate, endDate];
      this.queryList.dateStart = startDate;
      this.queryList.dateEnd = endDate;
    },
    handleReset() {
      this.queryList.regionId = '';
      this.queryList.states = [];
      this.queryList.customerIds = [];
      this.queryList.merchantCodes = [];
      this.queryList.packageType = '';
      this.getRSData();
      this.getCustomerPage();
      this.getMerchantList();
      this.initDateRange();
      this.handleSearch();
    },
    // 切换 SLA / Delivery / Time Out
    handleModeChange(mode) {
      this.queryList.mode = mode;
      this.handleSearch();
    },
    handleSearch() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.queryList.dateStart = this.dateRange[0];
        this.queryList.dateEnd = this.dateRange[1];
      }
      if (!this.queryList.dateStart || !this.queryList.dateEnd) {
        this.$message.warning(this.$i18n.locale === 'zh' ? '请选择查询时间范围' : 'Selecione o intervalo de datas');
        return;
      }
      // 清空旧数据
      this.dailyRes = {};
      this.weeklyRes = {};
      this.monthlyRes = {};
      const baseParams = JSON.parse(JSON.stringify(this.queryList));
      const load = Loading.service({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: this.$t('collectionCenter.loading'),
        background: 'rgba(250, 250, 250, 0.6)'
      });
      // 并行请求三个粒度（DAY / WEEK / MONTH）的准时签收达成数据
      Promise.all([
        onTimeSignRateAchieve({ ...baseParams, granularity: 'DAY' }),
        onTimeSignRateAchieve({ ...baseParams, granularity: 'WEEK' }),
        onTimeSignRateAchieve({ ...baseParams, granularity: 'MONTH' })
      ]).then(([dailyRes, weeklyRes, monthlyRes]) => {
        this.getUpdateTime();
        // 数据下发至各达成子组件，由子组件内部解析渲染
        this.dailyRes = dailyRes || {};
        this.weeklyRes = weeklyRes || {};
        this.monthlyRes = monthlyRes || {};
      }).catch(() => {
        this.dailyRes = {};
        this.weeklyRes = {};
        this.monthlyRes = {};
      }).finally(() => {
        load.close();
      });
    },

    // 获取大区/州筛选数据
    getRSData() {
      onTimeSignRateRSFilter().then(res => {
        if (res.code === 200) {
          this.regionList = res.data.regions || [];
          // 未选择大区时展示所有大区的州（去重）
          this.stateList = this.getStatesByRegion('');
        }
      });
    },
    // 大区变化时联动过滤州：未选择大区则展示全部州（去重），选择后展示该大区下的州
    handleRegionChange(val) {
      this.queryList.states = [];
      this.stateList = this.getStatesByRegion(val);
    },
    // 根据大区获取州列表（regionId 为空时取所有大区的州并去重）
    getStatesByRegion(regionId) {
      if (!this.regionList || this.regionList.length === 0) return [];
      if (!regionId) {
        const allStates = [];
        this.regionList.forEach(item => {
          (item.states || []).forEach(state => {
            if (!allStates.includes(state)) allStates.push(state);
          });
        });
        return allStates;
      }
      const region = this.regionList.find(item => item.regionId === regionId);
      return region ? region.states || [] : [];
    },
    handleCustomerChange(val) {
      if (!val || val.length === 0) {
        this.selectedCustomerList = [];
        this.queryList.merchantCodes = [];
        this.merchantList = [];
        return;
      }
      // 记录选中的客户对象（合并当前展示列表中已选项与历史已选项），供搜索后追加展示
      const selectedMap = {};
      (this.customerList || []).forEach(item => {
        if (val.includes(item.id)) selectedMap[item.id] = item;
      });
      (this.selectedCustomerList || []).forEach(item => {
        if (val.includes(item.id)) selectedMap[item.id] = item;
      });
      this.selectedCustomerList = Object.values(selectedMap);

      const form = {
        customerIdList: val
      };
      getMerchantByCustomerIdList(form).then((res) => {
        if (res.code === 200) {
          this.merchantList = res.data;
        }
      });
    },
    // 将已选中的客户补充到搜索结果尾部，避免选中项因 10 条分页限制遗漏展示
    mergeSelectedCustomers(records) {
      const list = records || [];
      const existIds = {};
      list.forEach(item => {
        existIds[item.id] = true;
      });
      (this.selectedCustomerList || []).forEach(item => {
        if (!existIds[item.id]) {
          list.push(item);
          existIds[item.id] = true;
        }
      });
      return list;
    },
    getCustomerPage(name = '', flag) {
      const param = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          quickSearch: ''
        }
      };
      if (flag) {
        if (this.customerList.length === 0) {
          apiCustomerPage(param).then((res) => {
            if (res.code === 200) {
              this.customerList = this.mergeSelectedCustomers(res.data.records);
            }
          });
        }
      } else {
        param.params.quickSearch = name;
        apiCustomerPage(param).then((res) => {
          if (res.code === 200) {
            this.customerList = this.mergeSelectedCustomers(res.data.records);
          }
        });
      }
    },
    getMerchantList() {
      const data = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          merchantName: ''
        }
      };
      apimerchantName(data).then((res) => {
        if (res.code === 200) {
          this.merchantList = res.data.records;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
@import '~@/styles/element/00-tokens.scss';

@media screen and (max-width: 1200px) {
  .page-header {
    flex-wrap: wrap;
    row-gap: 10px;
    padding: 15px !important;
    padding-bottom: 5px !important;
  }
  .header-right {
    width: 100%;
    justify-content: space-between !important;
  }

  .search-form .el-form-item {
    margin-bottom: 10px !important;
  }
  .search-buttons {
    margin-left: 5px;
    margin-top: 0 !important;
  }
}
@media screen and (max-width: 1420px) {
  .search-buttons {
    margin-top: 10px;
  }
}

.app-container {
  background-color: #fff;
  min-height: 100%;
  width: 100%;
  padding-bottom: 20px;
  color: #303133;
}
.app-container .el-divider {
  background-color: #ebeef5;
  margin: 10px 0 !important;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 35px 15px 25px 15px;
}
.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #1f2d3d;
  flex-shrink: 0;
  margin-right: 16px;
}

.header-right {
  display: flex;
  min-width: 0;
  justify-content: flex-end;
  align-items: center;
}

.header-right .el-button {
  min-width: 92px;
  border: 1px solid #dcdfe6;
  border-radius: 9px;
  padding: 8px 18px;
  font-size: 11px;
  font-weight: 700;
  color: #606266;
  background: #fff;
  cursor: pointer;
  transition: .2s ease;
  &:hover {
    color: $primary;
    border-color: $primary;
  }
}

.header-right .el-button--primary {
  background-color: $primary;
  border-color: $primary;
  color: #fff;
  &:hover {
    border-color: #12b866;
  }
}

.update-time {
  margin-left: 16px;
  font-size: 13px;
  color: #909399;
  .time-text {
    color: #303133;
    font-weight: 700;
  }
}

.search-card {
  background-color: #fff;
  border-color: #ebeef5;
  margin: 12px 15px;
}

.search-card ::v-deep .el-card__body {
  padding: 10px;
}

.search-form .el-form-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0;
  margin-right: 0;
}

.search-form .el-form-item ::v-deep .el-form-item__label {
  text-align: left;
  font-size: 12px;
  line-height: 14px !important;
  color: #606266;
  margin-bottom: 5px;
  margin-top: 5px;
}

.search-form .el-form-item ::v-deep .el-form-item__content {
  width: 100%;
  line-height: 1;
}

.search-form ::v-deep .el-select,
.search-form ::v-deep .el-date-editor {
  width: 100%;
}

.search-form ::v-deep .el-input__inner,
.search-form ::v-deep .el-range-input,
.search-form ::v-deep .el-range-separator {
  background-color: #fff;
  border-color: #dcdfe6;
  color: #303133;
}
.search-form ::v-deep .el-input__inner::placeholder,
.search-form ::v-deep .el-range-input::placeholder {
  color: #c0c4cc;
}

.search-buttons {
  display: inline-block;
  width: auto;
}

/* 隐藏/显示所有 QTD 列按钮 */
.qtd-toggle {
  display: inline-block;
  margin-left: auto;
}
.qtd-toggle-btn.el-button {
  min-width: 32px;
  padding: 8px 10px;
  border-radius: 9px;
  background: #f3f3f3 !important;
  color: #606266;
  border: none;
}
.qtd-toggle-btn.el-button:hover {
  color: $primary;
  border-color: $primary;
}

/* 图标统一尺寸：el-icon-view 与 closeEyes.png 保持一致 */
.qtd-toggle-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  vertical-align: middle;
  color: #1b2439;
}
.hover-move.resetBtn {
  border: 1px solid #dcdfe6 !important;
  background: #fff !important;
  color: #606266 !important;
}
.hover-move.resetBtn:hover {
  border-color: $primary !important;
  color: $primary !important;
  background: #f5f7fa !important;
}
.hover-move:hover {
  transform: translateY(-1px);
}
</style>
